import { MatDialogRef } from '@angular/material/dialog';

import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { locale as english } from '../i18n/en';
import { locale as vietnam } from '../i18n/vn';

export class BaseBasicDialog {
  constructor(
    public dialogRef: MatDialogRef<any>,
    protected _fuseTranslationLoaderService: FuseTranslationLoaderService,
    protected _fuseProgressBarService: FuseProgressBarService
  ) {
    this._fuseTranslationLoaderService.loadTranslations(english, vietnam);
  }
}
